module.exports = __webpack_public_path__ + "img/quad-water-md.08f850d4.svg";